import { ROLES } from './roles';

/**
 * Usuarios de ejemplo. Cada rol define qué dashboard y navegación ve la
 * persona autenticada. `password` solo existe para esta simulación local
 * y nunca debería viajar más allá de `authService`.
 *
 * @typedef {Object} User
 * @property {string} id
 * @property {string} name
 * @property {string} username
 * @property {string} password
 * @property {'data_entry'|'analyst'|'admin'} role
 * @property {string} region
 * @property {boolean} active
 */

/** @type {User[]} */
export const USERS = [
  {
    id: 'u1',
    name: 'Camila Rojas',
    username: 'camila.rojas',
    password: 'demo123',
    role: ROLES.DATA_ENTRY,
    region: 'Bogotá · Zona Norte',
    active: true,
  },
  {
    id: 'u2',
    name: 'Julián Torres',
    username: 'julian.torres',
    password: 'demo123',
    role: ROLES.DATA_ENTRY,
    region: 'Medellín · Centro',
    active: true,
  },
  {
    id: 'u3',
    name: 'Mariana Gil',
    username: 'mariana.gil',
    password: 'demo123',
    role: ROLES.DATA_ENTRY,
    region: 'Cali · Oriente',
    active: false,
  },
  {
    id: 'u4',
    name: 'Laura Méndez',
    username: 'laura.mendez',
    password: 'demo123',
    role: ROLES.ANALYST,
    region: 'Nacional',
    active: true,
  },
  {
    id: 'u5',
    name: 'Diego Salazar',
    username: 'diego.salazar',
    password: 'demo123',
    role: ROLES.ANALYST,
    region: 'Nacional',
    active: true,
  },
  {
    id: 'u6',
    name: 'Andrés Pardo',
    username: 'andres.pardo',
    password: 'demo123',
    role: ROLES.ADMIN,
    region: 'Nacional',
    active: true,
  },
];
